import ChangeBranchState from "@DSG/Store/Pages/Header/ChangeBranch/ChangeBranchState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

import { Draft } from "immer";

// In the below code example we have declare the initial value for the ShareCartState.
// It means when component load then the initial value of the isOpen property will be true.

const initialCounterState: ChangeBranchState = { changeBranch: false };

// In the below code example, we have create the reducer and changing the isOpen property state with new value that we will getting into the action

const changeBranchStateImmerReducer = createTypedReducerWithImmer(initialCounterState, {
    "ChangeBranch/Popup/Reset": (draft: Draft<ChangeBranchState>) => {
        return initialCounterState;
    },
    "ChangeBranch/Popup/Flag": (draft: Draft<ChangeBranchState>, action: { changeBranch: boolean }) => {
        draft.changeBranch = action.changeBranch;
        return draft;
    },
});

// In the below code example, we have are injecting the our new reducer in existing predefined reducers object.

(reducers as any).changeBranch = changeBranchStateImmerReducer;

type ChangeBranchReducers = {
    changeBranch: typeof changeBranchStateImmerReducer;
};

export type ChangeBranchActions = Parameters<ChangeBranchReducers[keyof ChangeBranchReducers]>[1] | AnyAction;
